<template>
    <div>
      <div class="h2 mb-0">
      </div>
        <nav class=" bg-base-color" style="padding: 0;text-align: center">
            <div class="d-none d-sm-none d-md-none d-lg-inline-flex" >
                <b-button class="form-control home-button"  :pressed="isReport" @click="onReport()">
                    <img style="width: 25px"
                         src="../assets/data-d.png"> ระบบรายงานข้อมูล
                </b-button>
                <b-button class="form-control home-button"  :pressed="isDashboard" @click="onDashboard()">
                    <img style="width: 20px"
                         src="../assets/graph-d.png">
                    รายงานสถานการณ์
                </b-button>
                <b-button class="form-control home-button pt-0"  >
                    <profile-status></profile-status>
                </b-button>
            </div>
        </nav>
        <nav class="bg-base-color d-lg-none d-xl-none" style="padding: 0;text-align: right">
            <b-button v-b-toggle.collapse-1 class="bg-base-color " style="border: 0;">
                <span class="font-default-color" style="font-size: 20px"><b-icon-list></b-icon-list></span>
            </b-button>
        </nav>
        <b-collapse id="collapse-1" class="d-lg-none d-xl-none ">
            <b-button class="form-control home-button" :pressed="isReport" @click="onReport()">
                <img style="width: 25px"
                     src="../assets/data-d.png"> ระบบรายงานข้อมูล
            </b-button>
            <b-button class="form-control home-button " :pressed="isDashboard" @click="onDashboard()">
                <img style="width: 20px"
                     src="../assets/graph-d.png">
                รายงานสถานการณ์
            </b-button>
            <b-button class="form-control home-button">
                <profile-status></profile-status>
            </b-button>
        </b-collapse>
    </div>
</template>

<script>
    import {mapState} from "vuex";
    import moment from "moment";
    import {domain, domain_dashboard} from "../util/Constants";
    import ProfileStatus from "./ProfileStatus";


    export default {
        name: "Header",
        components: {ProfileStatus},
        created() {
            this.checkLogin();
            this.getCurrentDate();
        },
        computed: {
            ...mapState({
                users: state => {
                    return state.Auth.users
                },
                form: state => {
                    return state.Event.form;
                },
                form_patient: state => {
                    return state.Patient.form;
                },
            })
        },
        data() {
            return {
                currentDate: "",
                isReport: true,
                isDashboard: false,
            };
        },
        methods: {
            onReport() {
                this.isReport = true;
                this.isDashboard = false;
                const path = `/home`
                if (this.$route.path !== path) this.$router.push(path)
            },
            onDashboard() {
                // this.isReport = false;
                // this.isDashboard = true;

              window.open(domain_dashboard)

            },
            getCurrentDate() {
                this.currentDate = moment().format("YYYY-MM-DD");
            },
            checkLogin() {
                if (this.users == null) {
                    this.$router.push({
                        name: "LoginView"
                    });
                }
            },
            goToDrowningForm(event_id, order = "") {
                this.$store.dispatch("Patient/showPatient", {
                    event_id: event_id,
                    order: order

                }).then(() => {
                    if (this.form_patient.id) {
                        this.$router.push({
                            name: "DrowningForm",
                            params: {order},
                        });
                    } else {
                        this.$router.push({
                            name: "DrowningForm",
                            params: {order}
                        })
                        this.$store.dispatch("Patient/clearFormData")
                        this.$store.dispatch("Patient/setOrder", order);
                    }
                })
            },
            printEventPDF(id) {
                window.open(domain + '/event_pdf/' + id, '_blank')
            },
            printPatientPDF(id) {
                window.open(domain + '/event_pdf/' + id, '_blank')
            },

        }
    }
</script>

<style scoped>

    .home-button {
        line-height: 25px;
        font-size: 18px;
        font-weight: bold;
        border-left: 1px solid #B9B9B9;
        border-right: 1px solid #B9B9B9;
        border-top: 0px;
        border-bottom: 0px;
        white-space: nowrap;
        border-radius: 0;
        background: #EFEFEF;
        color: #2DA1A9;
        text-align: center;
    }

</style>
